import { network } from 'services/network';

import { QueryParams } from 'api/queries/getBoardInit.query';

export const getCardUrgent = (params: QueryParams) => {
    const url = `api/bo/boardinit/getCardUrgent?metaDataId=${params.metaDataId}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
